import React from 'react'

import { Box, Divider, Menu, MenuItem } from '@mui/material'

import LogoutButton from '../LogoutButton'
import UserAccountSelect from './UserAccountSelect'
import formatName from '../../../../utils/formatName'

import { Organization, useUserProfileOptionsQuery } from '../../../../generated/graphql'

interface Props {
    anchor: HTMLElement | null | undefined
    auctionPickerOpenRequest?: number
    handleClose: () => void
    open: boolean
}

const UserSettingsMenu = ({ auctionPickerOpenRequest, open, handleClose, anchor }: Props): React.ReactElement => {
    const { data } = useUserProfileOptionsQuery()
    const isGlobalAdmin = data?.user?.attributes?.isGlobalAdmin || false

    const organizations = (data?.user?.organizations as Organization[]) || []

    const activeOrganization = data?.activeOrganization || ({ orgId: '' } as Organization)

    const { name, familyName, isAdmin } = (data && data.profile) || {}

    return (
        <Menu
            anchorEl={anchor}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            keepMounted
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            open={open}
            onClose={handleClose}
        >
            <div>
                <MenuItem onClick={handleClose} disabled>
                    {formatName({ firstName: name, lastName: familyName })}
                    {isAdmin ? ' (Admin)' : null}
                </MenuItem>
                <Box sx={{ display: { xs: organizations.length < 2 ? 'none' : undefined, md: 'none' } }}>
                    <Divider />
                    <MenuItem>
                        <UserAccountSelect
                            organizations={organizations}
                            handleClose={handleClose}
                            activeOrganization={activeOrganization}
                            isGlobalAdmin={isGlobalAdmin}
                            openRequest={auctionPickerOpenRequest}
                        />
                    </MenuItem>
                </Box>
                <Divider />
                <LogoutButton />
            </div>
        </Menu>
    )
}

export default UserSettingsMenu
